import { configureStore } from "@reduxjs/toolkit";
import savedPlacesSlice from './savedPlacesSlice';
import userDetailsSlice from './userDetailsSlice';
import planAtripSlice from './planAtripSlice';

const store = configureStore({
    reducer: {
        savedPlaces: savedPlacesSlice,
        userDetails: userDetailsSlice,
        planATrip : planAtripSlice,
    }
})

// Type for AppDispatch
export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof store.getState>;
export default store;
